// @ts-nocheck
import * as wNumb from 'wnumb';

/**
 * thousands of pounds lib-range (nouislider) tooltip format
 */
export const tooltipFormat = wNumb.default({
  mark: '.',
  thousand: ',',
  prefix: '£',
  // suffix: 'K',
  decimals: 0,
  // encoder: (value) => value * 0.001,
  // decoder: (value) => value * 1000,
});

export const getTextWidth = (text: string, font: string) => {
  // re-use canvas object for better performance
  const canvas = getTextWidth.canvas || (getTextWidth.canvas = document.createElement('canvas'));
  const context = canvas.getContext('2d');
  context.font = font;
  const metrics = context.measureText(text);
  return metrics.width;
};

export const URL_MATCH_REGEX = /^[A-Za-z][A-Za-z\d.+-]*:\/*(?:\w+(?::\w+)?@)?[^\s/]+(?::\d+)?(?:\/[\w#!:.?+=&%@\-/]*)?$/;
